const ACTIVITY_FIELD_PATTERN = /^(?:p2_)?activity_[1-5]$/;

function hasLinkedSelectionFields(fieldKey: string): boolean {
  return fieldKey === 'calc_insurance' || ACTIVITY_FIELD_PATTERN.test(fieldKey);
}

/** Includes derived selector overrides, even when the selected code itself is not overridden. */
export function hasRegistrationFieldOverride(overrides: Record<string, unknown>, fieldKey: string): boolean {
  return (
    overrides[fieldKey] != null ||
    (hasLinkedSelectionFields(fieldKey) &&
      (overrides[`${fieldKey}_name`] != null || overrides[`${fieldKey}_uuid`] != null))
  );
}

/** Restore submission data by removing overrides, not by copying the original value into the draft. */
export function restoreRegistrationFieldOverride(
  overrides: Record<string, unknown>,
  fieldKey: string
): Record<string, unknown> {
  const restored = { ...overrides };
  delete restored[fieldKey];
  if (hasLinkedSelectionFields(fieldKey)) {
    delete restored[`${fieldKey}_name`];
    delete restored[`${fieldKey}_uuid`];
  }
  return restored;
}
